import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { EquipmentBrakes, ListItem, RepositoryModal } from '../../shared'
import { EquipmentBrakesListComponent } from './equipment-brakes-list.component'
import { PartsFluidsEquipmentContext } from './parts-fluids-equipment-context'

@Component({
    templateUrl: './equipment-brakes-modal.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent, WjInputModule],
})
export class EquipmentBrakesModalComponent extends RepositoryModal<EquipmentBrakes> {
    equipmentOptions: ListItem<string>[] = []

    protected onInitialized() {
        this.equipmentOptions = (this.editOptions.initializeParams as EquipmentBrakesListComponent).equipmentOptions
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        super.onSave(
            result => {
                ;(this.editOptions.initializeParams as EquipmentBrakesListComponent).parent.refresh()
                resolveSave(result)
            },
            rejectSave,
        )
    }
}
